'use client';

import { useServerInsertedHTML } from 'next/navigation';
import { useRef } from 'react';

type JsonLdProps = {
    data: object;
    id?: string;
};

export default function JsonLd({ data, id }: JsonLdProps) {
    const json = JSON.stringify(data).replace(/</g, '\\u003c');
    const inserted = useRef(false);

    useServerInsertedHTML(() => {
        if (inserted.current) return null;

        inserted.current = true;
        return (
            <script id={id} type='application/ld+json' dangerouslySetInnerHTML={{ __html: json }} />
        );
    });

    return null;
}
